import { render, staticRenderFns } from "./PlayAudioButon.vue?vue&type=template&id=41c34886&scoped=true&lang=pug&"
import script from "./PlayAudioButon.vue?vue&type=script&lang=ts&"
export * from "./PlayAudioButon.vue?vue&type=script&lang=ts&"
import style0 from "./PlayAudioButon.vue?vue&type=style&index=0&id=41c34886&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c34886",
  null
  
)

export default component.exports